import { createI18n } from 'vue-i18n';
import messages from './messages';

const savedLocale = localStorage.getItem('locale') || 'uz';

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'uz',
  messages,
});

export default i18n;

